export { default } from './UnscoredCategoryPageTemplate'
